module.exports = __webpack_public_path__ + "static/colgadas-020-258b28d16d1d1328fea6280b0642bb00.jpg";